import '../landing/main.scss';
import { createApp } from 'vue';
import axios from 'axios';
import LandingApp from '../landing/LandingApp.vue';
import router from '../landing/router';
import store from '../landing/store';

// Configure axios globally
window.axios = axios;

const mountLanding = () => {
  const root = document.getElementById('landing-app');
  if (!root) {
    console.warn('Landing app root element not found');
    return;
  }

  const app = createApp(LandingApp);
  
  // Use router and store
  app.use(router);
  app.use(store);

  // Mount app
  app.mount(root);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountLanding);
} else {
  mountLanding();
}
